module.exports = __webpack_public_path__ + "img/redflag.e19f2ab3.jpeg";